import React from 'react';
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import StatsTable from "./StatsTable";
import {useDispatch, useSelector} from "react-redux";
import {makeActiveNotification} from "../../../../Containers/Notifications/notificationSelectors";
import moment from "moment";
import {Tooltip} from "@material-ui/core";
import InfoIcon from "@material-ui/icons/Info";
import {selectLoadingStats} from "../../../../redux/ui/uiSelectors";
import Button from "@material-ui/core/Button";
import {makeStyles} from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";
import * as notificationRoutines from "../../../../Containers/Notifications/notificationsRoutines";

const DailyStats = ({localClasses, globalClasses}: any) => {


    const dispatch = useDispatch()
    const activeNotification = useSelector(makeActiveNotification);
    const loadingStats  = useSelector(selectLoadingStats)
    const handleRefresh = () =>{
        dispatch(notificationRoutines.getStatsForPushNotifications());
    }
    const day = moment(activeNotification.timestamp).format('ll')

    const useStyles = makeStyles(theme => ({
        button: {
            margin: theme.spacing(1),
            color: theme.palette.common.white,
            '&:hover':{
                background:'rgb(64, 110, 152)'
            }
        },
        input: {
            display: 'none',
        },
        formControl: {
            margin: theme.spacing(1),
        },
    }));

    const classes = useStyles();


    const Ta = () => (
        <span>Daily stats | {day}
            <div style={{display:'flex', alignItems:'center', transform: 'translateY(-50%)', top: '50%', cursor: 'pointer', position:'absolute', right: 25}}>
             <Button
                 color="secondary" variant="contained"
                 classes={{ root: classes.button }}
                 data-cy="Dashboard-profile-name-save"
                 onClick={handleRefresh}>
                        Refresh
                    </Button>
             <Tooltip  placement="top-start" title={"Updated stats may take up to a couple minutes to be available after sending a new push."}>
                <InfoIcon style={{color:'white'}} color="action" />
            </Tooltip>
                </div>
        </span>
    )
    return (
        <Card className={localClasses.card}>
            <CardHeader classes={{root: globalClasses.cardHeader}} title={<Ta/>}/>
            <CardContent className={localClasses.content}>

                {loadingStats ?  <CircularProgress /> :<StatsTable/> }
            </CardContent>
        </Card>
    )
}

export default DailyStats;